module.exports = __webpack_public_path__ + "img/statistics (1) 1.10565f23.png";